import { createRootRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Spinner } from '../components/shadcn/Spinner';
import { useAuth } from '../context/useAuth';
import { useNavigateAfterLogin } from '../utils/router';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { session, isSessionPending } = useAuth();
  const navigateAfterLogin = useNavigateAfterLogin();
  const isLoginPage = location.pathname === '/login';
  const isResetPasswordPage = location.pathname === '/reset-password';

  useEffect(() => {
    if (isSessionPending) return;
    if (isLoginPage || isResetPasswordPage) {
      navigateAfterLogin();
      return;
    }
    if (location.pathname === '/') {
      navigateAfterLogin();
      return;
    }
    if (!session) {
      navigate({ to: '/login', replace: true });
    }
  }, [
    isSessionPending,
    navigateAfterLogin,
    isLoginPage,
    isResetPasswordPage,
    location.pathname,
    session,
    navigate,
  ]);

  if (isSessionPending) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <Spinner className="size-8" />
      </div>
    );
  }

  if (isLoginPage || isResetPasswordPage) {
    return <Outlet />;
  }

  if (!session) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <Spinner className="size-8" />
      </div>
    );
  }

  return (
    <div className="relative flex w-screen h-screen overflow-hidden">
      <Sidebar />
      <main className="relative flex-1 bg-gray-50 overflow-y-auto pt-14 md:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
